export const FETCH_TEACHER_NAVIGATION = "FETCH_TEACHER_NAVIGATION";
export const SET_TEACHER_NAVIGATION = "SET_TEACHER_NAVIGATION";
export const SET_TEACHER_NAVIGATION_PROPS = "SET_TEACHER_NAVIGATION_PROPS";

export function SetNavigationTab(tabNr) {
  return function (dispatch) {
    dispatch({
      type: "SET_TEACHER_NAVIGATION",
      payload: { tabNr: tabNr },
    });
  };
}

export function SetNavigationProps(propName, propVar) {
  return function (dispatch) {
    dispatch({
      type: "SET_TEACHER_NAVIGATION_PROPS",
      payload: { propName: propName, propVar: propVar },
    });
  };
}

export function GetNavigationTab() {
  return function (dispatch) {
    dispatch({
      type: "FETCH_TEACHER_NAVIGATION",
    });
  };
}
